import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromIndirectRateRule from './indirect-rate-rule.reducer';

export const selectIndirectRateRuleState = createFeatureSelector<
    fromIndirectRateRule.State
>(fromIndirectRateRule.indirectRateRulesFeatureKey);

export const {
    selectIds,
    selectEntities,
    selectAll,
    selectTotal
} = fromIndirectRateRule.adapter.getSelectors(selectIndirectRateRuleState);
